import { ThunkAction } from 'redux-thunk';
import * as Bixby from './../../core';
import { AppState } from './..';
import {
  CLO_LOADING,
  CLO_FAILURE,
  CLO_SUCCESS,
  HEATMAP_OFF,
  HEATMAP_ON,
  ALL_CLO_SUCCESS,
  CREATE_CLO,
  ADD_CLIENT_CLO,
  ADD_CLIENT_CLO_FAILURE,
  ADD_CLIENT_CLO_SUCCESS,
  DELETE_CLIENT_CLO,
  DELETE_CLIENT_CLO_SUCCESS,
  DELETE_CLIENT_CLO_FAILURE,
} from './types';
import { CloService } from '$/services';
import { toastError, toastSuccess } from '../toast/actions';

export const loadCloAction = () => {
  return {
    type: CLO_LOADING,
  };
};

export const cloSuccessAction = (payload: Bixby.Models.Clo) => {
  return {
    type: CLO_SUCCESS,
    payload,
  };
};

export const cloFailureAction = (payload: Bixby.Models.BixbyError) => {
  return {
    type: CLO_FAILURE,
    payload,
  };
};


export const loadCloDealAction = () => {
  return {
    type: CLO_LOADING,
  };
};

export const cloDealSuccessAction = (payload: Bixby.Models.CloDeal) => {
  return {
    type: CLO_SUCCESS,
    payload,
  };
};

export const cloDealFailureAction = (payload: Bixby.Models.BixbyError) => {
  return {
    type: CLO_FAILURE,
    payload,
  };
};

export const heatMapOnAction = (payload: boolean) => {
  return {
    type: HEATMAP_ON,
    payload,
  };
};

export const heatMapOffAction = (payload: boolean) => {
  return {
    type: HEATMAP_OFF,
    payload,
  };
};

export const allCloSuccessAction = (payload: Bixby.Models.CloSlim[]) => {
  return {
    type: ALL_CLO_SUCCESS,
    payload,
  };
};

const createCloAction = (clo: Bixby.Models.Clo) => {
  return {
    type: CREATE_CLO,
    payload: clo,
  };
};

const addClientCloAction = () => {
  return {
    type: ADD_CLIENT_CLO,
  };
};

const addClientCloSuccessAction = () => {
  return {
    type: ADD_CLIENT_CLO_SUCCESS,
  };
};

const addClientCloFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ADD_CLIENT_CLO_FAILURE,
    payload: error,
    addError: true,
  };
};

const deleteClientCloAction = () => {
  return {
    type: DELETE_CLIENT_CLO,
  };
};

const deleteClientCloSuccessAction = () => {
  return {
    type: DELETE_CLIENT_CLO_SUCCESS,
  };
};

const deleteClientCloFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: DELETE_CLIENT_CLO_FAILURE,
    payload: error,
    deleteError: true,
  };
};

export const getCloById = (
  cloId: string
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
  dispatch(loadCloAction());
  try {
    const clo = await CloService.getCloById(cloId);
    dispatch(cloSuccessAction(clo));
  } catch (error : any) {
    dispatch(cloFailureAction(error));
  }
};

export const setHeatMapActive =
  (isActive: boolean): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    if (isActive) {
      dispatch(heatMapOnAction(isActive));
    } else {
      dispatch(heatMapOffAction(isActive));
    }
  };

export const getAllClos =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(loadCloAction());
    try {
      const clos = await CloService.getAllClos();
      dispatch(allCloSuccessAction(clos));
    } catch (error: any) {
      dispatch(cloFailureAction(error));
    }
  };

export const createClo =
  (newClo: Bixby.Models.CreateCloRequest): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(loadCloAction());
    try {
      const clo = await CloService.createClo(newClo);
      dispatch(createCloAction(clo));
    } catch (error: any) {
      dispatch(cloFailureAction(error));
      await dispatch(toastError(`Error creating CLO`));
    }
  };

export const updateClo =
  (updateRequest: Bixby.Models.CloSlim): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(loadCloAction());
    try {
      const clo = await CloService.updateClo(updateRequest);
      dispatch(createCloAction(clo));
      await dispatch(toastSuccess(`CLO Updated Successfully`));
    } catch (error: any) {
      dispatch(cloFailureAction(error));
      await dispatch(toastError(`Clo Failed to Update`));
    }
  };

export const addClientClo = (
  clientId: string,
  cloId: string,
  onAddSuccess: () => void
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => 
  async dispatch => {
  dispatch(addClientCloAction());
  try {
    await CloService.addClientClo(clientId, cloId);
    dispatch(addClientCloSuccessAction());
    onAddSuccess();
    await dispatch(toastSuccess(`Added successfully`));
  } catch (error : any) {
    dispatch(addClientCloFailureAction(error));
    await dispatch(toastError(`CLO could not be added`));
  }
};

export const deleteClientClo = (
  clientId: string,
  cloId: string,
  onDeleteSuccess: () => void
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => 
  async dispatch => {
  dispatch(deleteClientCloAction());
  try {
    await CloService.deleteClientClo(clientId, cloId);
    await dispatch(deleteClientCloSuccessAction());
    onDeleteSuccess();
    await dispatch(toastSuccess(`CLO deleted successfully`));
  } catch (error : any) {
    dispatch(deleteClientCloFailureAction(error));
    await dispatch(toastError(`CLO could not be deleted`));
  }
};
